var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#7F91A5",
    d: "M20 21v5H1V4h1.86M18.14 4H20v8M5 11h10.512M5 21h8.515M16.25 11H15M5 16h4.528"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00234B",
    d: "M13 15.636L16.552 19 25 11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7F91A5",
    d: "M13 3.273C13 2.018 11.88 1 10.5 1S8 2.018 8 3.273H6V6h9V3.273h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTodo);
export default __webpack_public_path__ + "static/media/icon-todo.559e89f6064a71ec62b7adb85f32a43d.svg";
export { ForwardRef as ReactComponent };